import { Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const TranslationBar = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  flexShrink: 0,
});

export const DrawerHeader = styled(Box)({
  flexShrink: 0,
  position: 'relative',
  '&::after': {
    content: '""',
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    height: '8px',
    background:
      'linear-gradient(to bottom, rgba(0,0,0,0.06) 0%, transparent 100%)',
    pointerEvents: 'none',
    zIndex: 1,
  },
});

export const TranslationToggleButton = styled(Button)({
  padding: '0 12px',
  minWidth: 0,
  fontSize: '14px',
  textTransform: 'none',
  fontWeight: 400,
  '&:hover': {
    backgroundColor: 'transparent',
    textDecoration: 'underline',
  },
});

export const LearnMoreButton = styled(Button)({
  padding: '0 12px',
  minWidth: 0,
  fontSize: '14px',
  textTransform: 'none',
  fontWeight: 400,
  '&:hover': {
    backgroundColor: 'transparent',
    textDecoration: 'underline',
  },
});
